import { __extends } from "tslib";
import { packageWave } from '../../parsers/utils/parser/sound';
import { WaveAudio } from '@awayjs/core';
import { WaveAudioData } from '@awayjs/core';
import { MovieClipSoundsManager } from './MovieClipSoundsManager';
import { release } from '../base/utilities/Debug';
var WebAudioAdapter = /** @class */ (function () {
    function WebAudioAdapter(data) {
        this._byteLength = 0;
        this._sound = null;
        this._frameData = [];
        this._data = data;
        this._position = 0;
    }
    Object.defineProperty(WebAudioAdapter.prototype, "byteLength", {
        get: function () {
            return this._byteLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebAudioAdapter.prototype, "isComplete", {
        get: function () {
            return this._byteLength > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebAudioAdapter.prototype, "currentTime", {
        get: function () {
            return this._sound.currentTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebAudioAdapter.prototype, "sound", {
        get: function () {
            return this._sound;
        },
        enumerable: false,
        configurable: true
    });
    WebAudioAdapter.prototype.playFrom = function (time) {
        /*var startPlay=true;
        if(this._sound.duration<this._sound.currentTime){
          startPlay=false;
        }*/
        this.stop();
        //if(startPlay){
        this._sound.play(time);
        //}
    };
    WebAudioAdapter.prototype.stop = function () {
        if (this._sound)
            this._sound.stop();
    };
    Object.defineProperty(WebAudioAdapter.prototype, "paused", {
        get: function () {
            return false;
        },
        set: function (_value) { },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebAudioAdapter.prototype, "isPlaying", {
        get: function () {
            return this._sound.isPlaying;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebAudioAdapter.prototype, "isReady", {
        get: function () {
            return !!this._sound;
        },
        enumerable: false,
        configurable: true
    });
    WebAudioAdapter.prototype.queueData = function (frame) {
        if (!frame.pcm) {
            release || console.log('error in WebAudioAdapter.queueData - frame does not provide pcm data');
            return;
        }
        this._frameData.push(frame);
        this._byteLength += frame.data.length;
    };
    WebAudioAdapter.prototype.finish = function () {
        var finalBytes = new Int8Array(this._byteLength);
        for (var i = 0; i < this._frameData.length; i++) {
            finalBytes.set(this._frameData[i].data, this._position);
            this._position += this._frameData[i].data.length;
        }
        var packagedWave = packageWave(finalBytes, this._data.sampleRate, this._data.channels, this._data.streamSize, false);
        var sound = new WaveAudio(new WaveAudioData(packagedWave.data.buffer));
        this._sound = sound;
    };
    return WebAudioAdapter;
}());
var WebAudioMP3Adapter = /** @class */ (function (_super) {
    __extends(WebAudioMP3Adapter, _super);
    function WebAudioMP3Adapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebAudioMP3Adapter.prototype.queueData = function (frame) {
        if (!frame.data) {
            release || console.log('error in WebAudioAdapter.queueData - frame does not provide data');
            return;
        }
        this._frameData.push(frame);
        this._byteLength += frame.data.length;
    };
    WebAudioMP3Adapter.prototype.finish = function () {
        if (!this._byteLength) {
            throw 'Can\'t finish empty stream!';
        }
        var finalBytes = new Uint8Array(this._byteLength);
        for (var i = 0; i < this._frameData.length; i++) {
            finalBytes.set(this._frameData[i].data, this._position);
            this._position += this._frameData[i].data.length;
        }
        var sound = new WaveAudio(new WaveAudioData(finalBytes.buffer));
        this._sound = sound;
    };
    return WebAudioMP3Adapter;
}(WebAudioAdapter));
var MovieClipSoundStream = /** @class */ (function () {
    function MovieClipSoundStream(streamInfo) {
        this._stopped = false;
        this.decode = streamInfo.decode.bind(streamInfo);
        this.data = {
            sampleRate: streamInfo.sampleRate,
            channels: streamInfo.channels,
            streamSize: streamInfo.streamSize,
        };
        this.seekIndex = [];
        this.position = 0;
        this.isMP3 = streamInfo.format === 'mp3';
        this.soundStreamAdapter = !this.isMP3
            ? new WebAudioAdapter(this.data)
            : new WebAudioMP3Adapter(this.data);
    }
    MovieClipSoundStream.prototype.appendBlock = function (frameNum, streamBlock) {
        var decodedBlock = this.decode(streamBlock);
        var streamPosition = this.position;
        this.seekIndex[frameNum] = (streamPosition + decodedBlock.seek);
        this.position = streamPosition + decodedBlock.samplesCount;
        this.soundStreamAdapter.queueData(decodedBlock);
    };
    Object.defineProperty(MovieClipSoundStream.prototype, "stopped", {
        get: function () {
            return this._stopped;
        },
        set: function (value) {
            this._stopped = value;
        },
        enumerable: false,
        configurable: true
    });
    MovieClipSoundStream.prototype.stop = function () {
        this.soundStreamAdapter.stop();
    };
    MovieClipSoundStream.prototype.playFrame = function (frameNum) {
        if (this._stopped || isNaN(this.seekIndex[frameNum])) {
            return 0;
        }
        if (!this.soundStreamAdapter.isComplete) {
            return 0;
        }
        if (!this.finalized) {
            this.finalized = true;
            this.soundStreamAdapter.finish();
        }
        this.isPlaying = true;
        var soundStreamData = this.data;
        var time = this.seekIndex[frameNum] / soundStreamData.channels / soundStreamData.sampleRate;
        if (this.isMP3) {
            time *= soundStreamData.channels;
        }
        MovieClipSoundsManager.addActiveSound(this.soundStreamAdapter.sound);
        if (!this.soundStreamAdapter.isPlaying) {
            this.soundStreamAdapter.playFrom(time);
        }
        var elementTime = this.soundStreamAdapter.currentTime;
        var framestoSkip = (elementTime - time) * MovieClipSoundsManager.frameRate;
        if ((elementTime - time) < 0) {
            framestoSkip = Math.ceil(framestoSkip);
        }
        else {
            framestoSkip = Math.floor(framestoSkip);
        }
        //console.log("framestoSkip ", framestoSkip);
        return framestoSkip;
    };
    return MovieClipSoundStream;
}());
export { MovieClipSoundStream };
